import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container } from '../../../ui/gridSystem';
import { CTA, CustomSelect, Icon, Text } from '../../../ui/atoms';
import Tabs from '../../../ui/atoms/Tabs';
import {
  TabContent,
  TabsWrapper,
  TabsWrapperMobile,
  TextWrapper,
} from './style';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import Overview from '../../../ui/components/Tutor/Overview';
import Activities from '../../../ui/components/Tutor/Activities';
import Documents from '../../../ui/components/Tutor/Documents';
import Registration from '../../../ui/components/Tutor/Registration';
import {
  COURSE_CANCEL,
  TUTOR_ACTIVE_TAB_SET,
} from '../../redux/actions/tutors';
import ModalCancelCourse, {
  ModalCancelCourseId,
} from '../../../ui/atoms/Modals/ModalCancelCourse';
import { MODAL_OPEN } from '../../redux/actions';
import theme from '../../../ui/theme';
import EventOverviewTab from '../../../ui/components/Tutor/EventOverviewTab';
import SessionsTab from '../../../ui/components/Tutor/SessionsTab';
import ModalCategoryMedia from '../../../ui/atoms/Modals/ModalCategoryMedia';

const CreateCourse = ({
  isEvent = false,
  mediaIsPhone,
  tabs,
  activeTabValue,
  storeActiveTab,
  modalOpen,
  courseCancel,
}) => {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    setActiveTab(tabs[0]);
    storeActiveTab(1);
    setFirstRender(false);
    return () => {
      courseCancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!firstRender) storeActiveTab(activeTab.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab?.value]);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    if (!firstRender) {
      setActiveTab(tabs.find((t) => t?.value === activeTabValue));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTabValue]);

  return (
    <Container>
      <TextWrapper>
        <Text type="h1" mb={mediaIsPhone ? 8 : 0}>
          Creazione percorso formativo
        </Text>
        <CTA
          type="tertiary"
          btnText="ESCI DALLA MODALITà DI CREAZIONE"
          onClick={() => modalOpen(ModalCancelCourseId)}
          icon="x-close"
        />
        <Text
          type="h1.5"
          className="subtitle"
          mt={8}
          color={theme().colors.primaryDarkGray600}
        >
          {isEvent ? 'Evento' : 'Corso'}
        </Text>
      </TextWrapper>
      {mediaIsPhone ? (
        <TabsWrapperMobile>
          <Text type="h3">
            {activeTab?.label}
            {tabs?.find((t) => t.value === activeTab?.value)?.completed && (
              <Icon
                type="check-circle"
                stroke={theme().colors.successIcon}
                className="ml-2"
              />
            )}
          </Text>
          <CustomSelect
            options={tabs.map((t) => ({
              label: `${t.value}/${tabs?.length}`,
              value: t.value,
              isDisabled: t?.disabled,
            }))}
            placeholder={`1/${tabs?.length}`}
            onChange={({ value }) =>
              setActiveTab(tabs.find((t) => t.value === value))
            }
            selected={{
              label: `${activeTab?.value || tabs?.length}/${tabs?.length}`,
              value: activeTab?.value,
            }}
            value={`${activeTab?.value || tabs?.length}/${tabs?.length}`}
          />
        </TabsWrapperMobile>
      ) : (
        <TabsWrapper>
          <Tabs
            tabs={tabs}
            onChange={(t) => {
              setActiveTab(t);
            }}
            selected={activeTab}
            tabType="tertiary"
            showNumbers
            fullWidth
          />
        </TabsWrapper>
      )}
      <TabContent className={activeTab?.value === 1 ? 'active' : ''}>
        {isEvent ? <EventOverviewTab /> : <Overview />}
      </TabContent>
      <TabContent className={activeTab?.value === 2 ? 'active' : ''}>
        {isEvent ? <SessionsTab /> : <Activities />}
      </TabContent>
      <TabContent className={activeTab?.value === 3 ? 'active' : ''}>
        <Documents />
      </TabContent>
      <TabContent className={activeTab?.value === 4 ? 'active' : ''}>
        <Registration isEvent={isEvent} />
      </TabContent>
      <ModalCancelCourse />
      <ModalCategoryMedia />
    </Container>
  );
};

CreateCourse.propTypes = {
  isEvent: PropTypes.bool,
  mediaIsPhone: PropTypes.bool,
  // HOC: state
  tabs: PropTypes.array.isRequired,
  activeTabValue: PropTypes.number,
  // HOC: dispatch
  storeActiveTab: PropTypes.func,
  modalOpen: PropTypes.func,
  courseCancel: PropTypes.func,
};

export default connect(
  (state) => {
    const { tabs, activeTab: activeTabValue } = state.tutors;
    return {
      tabs,
      activeTabValue,
    };
  },
  (dispatch) => ({
    storeActiveTab: (tab) => dispatch({ type: TUTOR_ACTIVE_TAB_SET, tab }),
    modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
    courseCancel: () => dispatch({ type: COURSE_CANCEL._REQUEST }),
  })
)(withMediaQueries(CreateCourse));
